import ModalRoot from '@ui/components/ModalRoot'
import React from 'react'
//import ModalRoot from "@ui/components/ModalRoot"
import attention from '@assets/Ico_Attenzione.png'

type OcrErrorModalProps = {
	isOpen: boolean
	title?: string | null
	description?: string | null
	primaryLabel?: string
	secondaryLabel?: string
	onPrimary: () => void
	onSecondary: () => void
}
export function OcrErrorModal({
	isOpen,
	title = 'Documento non valido!',
	description,
	onPrimary,
	onSecondary,
}: OcrErrorModalProps) {
	if (!isOpen) return null

	return (
		<ModalRoot
			hideClose
			hideBorderLeft
			height='h-auto md:h-[350px] max-h-[90vh]'
			reverseButton
			onCallBack={onPrimary}
			labelOk='Riprova'
			labelClose='Elimina e sostituisci i documenti'
			isOpen={isOpen}
			onCloseModal={onSecondary}
		>
			<div className='py-5 sm:p-8 md:p-10 overflow-y-auto'>
				<div className='flex flex-row items-start gap-4 sm:gap-2.5'>
					<div className='shrink-0'>
						<img
							src={attention}
							alt=''
							className='w-12 h-12 md:w-14 md:h-14'
						/>
					</div>

					<div className='flex flex-col gap-2.5'>
						<div className='text-[22px] md:text-[28px] font-semibold leading-tight'>
							{title}
						</div>

						<div className='text-sm md:text-base leading-relaxed'>
							{description}
						</div>
					</div>
				</div>
			</div>
		</ModalRoot>
	)
}
